import { Ring } from "@uiball/loaders";

import PropTypes from "prop-types";

import { colors } from "../../consts";

import { SVG } from "../../components";
import { RefreshButtonStyled } from "./styled";

const RefreshButton = ({ isLoading, handleRefresh }) => {
  return (
    <RefreshButtonStyled disabled={isLoading} onClick={handleRefresh} isLoading={isLoading}>
      {isLoading ? (
        <Ring size={18} lineWeight={5} speed={2} color={colors.WHITE} />
      ) : (
        <SVG.RefreshIcon />
      )}
    </RefreshButtonStyled>
  );
};

RefreshButton.propTypes = {
  isLoading: PropTypes.bool,
  handleRefresh: PropTypes.func
};

export default RefreshButton;
